import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['blocks', 'checkboxes'];

  connect () {
    this.checkboxesTargets.forEach((checkbox) => {
      if(checkbox.checked) {
        this.toggleInputs({target: checkbox});
      }
    });
  }

  toggleInputs (event) {
    this.blocksTargets.forEach((block) => {
      const fieldValue = block.dataset.fieldValue;
      block.classList.toggle('d-none', event.target.value !== fieldValue);
    });
  }
}
